/**
 * Everything that can be limited or gated by a plan.
 *
 * Marketing-only rows from the pricing table (e-mail notifikácie, online rezervácie,
 * databáza klientov) are deliberately absent - they are available on every tier and there is
 * nothing to enforce.
 */
export enum FeatureKey {
  Customers = 'customers',
  ReservationsPerMonth = 'reservations_per_month',
  Employees = 'employees',
  Places = 'places',
  Activities = 'activities',
  EventBlueprints = 'event_blueprints',
  Announcements = 'announcements',
  DataExport = 'data_export',
  WebElements = 'web_elements',
  SmsNotifications = 'sms_notifications',
}

export const FEATURE_KEYS: FeatureKey[] = Object.values(FeatureKey)
